import React, { useState } from 'react';
import { Button } from '@mui/material';
import TaskIcon from '@mui/icons-material/Task';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const CustomSelectFileOrFiles = ({
  multiple,
  accept,
  title,
  disabled,
  onChange,
  id
}) => {
  const [names, setNames] = useState('');

  const handleFileMultipleInputChange = async event => {
    async function readFile(file) {
      return await new Promise(resolve => {
        let fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsText(file);
      });
    }

    const files = [];
    const filenames = [];

    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      filenames.push(file.name);
      try {
        const content = await readFile(file);
        const data = JSON.parse(content);
        const number = parseInt(data.filename.split('_')[1].split('.')[0], 10);
        files.push({ ...data, number });
      } catch (err) {
        console.error('Error leyendo archivo:', file.name, err);
      }
    }

    const newData = files
      .sort(({ number: a }, { number: b }) => a - b)
      .map(e => ({
        valor: e.firm[0].valor,
        datos: e.firm.map(info => info.datos.substr(2)).join('')
      }));

    if (newData.length) {
      newData[newData.length - 1].valor =
        '6F' + newData[newData.length - 1].valor.substr(2);
    }

    onChange(newData);
    setNames(filenames.join(', '));
    event.target.value = null;
  };

  const handleFileInputChange = async event => {
    async function readFile(file) {
      return await new Promise(resolve => {
        let fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsText(file);
      });
    }

    const file = event.target.files[0];
    const content = await readFile(file);
    onChange({ name: file.name, ...JSON.parse(content) });
    setNames(file.name);
    event.target.value = null;
  };

  const handleClear = () => {
    onChange(null);
    setNames('');
  };

  return (
    <>
      <Button variant="outlined" color="secondary" disabled={disabled}>
        <label htmlFor={id} style={{ cursor: 'pointer' }}>
          {title}
        </label>
        <input
          id={id}
          type="file"
          accept={accept}
          onChange={
            multiple ? handleFileMultipleInputChange : handleFileInputChange
          }
          multiple={multiple}
          style={{ display: 'none' }}
        />
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleClear}
        disabled={!disabled}
      >
        Borrar
      </Button>
      {disabled ? <TaskIcon /> : <NoteAddIcon />} - {names}
    </>
  );
};

export default CustomSelectFileOrFiles;
